var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgTwitter = function SvgTwitter(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    rx: 12.5,
    fill: "#AAB1F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5578 6H19.9942L14.6448 12.0909L20.8946 20.3533H15.9901L12.1502 15.3323L7.75415 20.3533H5.31779L10.985 13.8387L5 6H10.0263L13.4955 10.5867L17.5578 6ZM16.7051 18.9233H18.0557L9.31659 7.37707H7.86537L16.7051 18.9233Z",
    fill: "#080F4D"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTwitter);
var Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNSAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjI1IiBoZWlnaHQ9IjI1IiByeD0iMTIuNSIgZmlsbD0iI0FBQjFGMiIvPgo8cGF0aCBkPSJNMTcuNTU3OCA2SDE5Ljk5NDJMMTQuNjQ0OCAxMi4wOTA5TDIwLjg5NDYgMjAuMzUzM0gxNS45OTAxTDEyLjE1MDIgMTUuMzMyM0w3Ljc1NDE1IDIwLjM1MzNINS4zMTc3OUwxMC45ODUgMTMuODM4N0w1IDZIMTAuMDI2M0wxMy40OTU1IDEwLjU4NjdMMTcuNTU3OCA2Wk0xNi43MDUxIDE4LjkyMzNIMTguMDU1N0w5LjMxNjU5IDcuMzc3MDdINy44NjUzN0wxNi43MDUxIDE4LjkyMzNaIiBmaWxsPSIjMDgwRjREIi8+Cjwvc3ZnPgo=";